module.exports = __webpack_public_path__ + "static/media/Sekk.292ab756.PNG";